export default __webpack_public_path__ + "static/media/card-to-card-info-icon-2.37f988b0.svg";